export default __webpack_public_path__ + "images/a4df9a253fe47d9e75b87a0544c24139-mental_health_icon.png";